import { render, staticRenderFns } from "./PrintArticle.vue?vue&type=template&id=38f926ce&scoped=true"
import script from "./PrintArticle.vue?vue&type=script&lang=js"
export * from "./PrintArticle.vue?vue&type=script&lang=js"
import style0 from "./PrintArticle.vue?vue&type=style&index=0&id=38f926ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f926ce",
  null
  
)

export default component.exports